export default __webpack_public_path__ + "static/media/arrow-left-3-icon.087294c1.svg";